interface Item {
	name?: string | undefined;
}

export default (a: Item, b: Item): number => {
	if (!a.name || !b.name) return 0;
	return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
};
